import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigate } from './navigationService';
export const NavigationInitializer = () => {
    const navigate = useNavigate();
    useEffect(() => {
        setNavigate(navigate);
    }, [navigate]);
    return null;
};
export default NavigationInitializer;
